import { Component, Input, OnInit, signal } from '@angular/core';
import { SHeaderComponent } from '../../shared/s-header/s-header.component';
import { BaseImageGalleryComponent } from './base-image-gallery/base-image-gallery.component';
import { CBaseComponent } from '../base/c-base.component';
import { ElementsType } from '../../../state-management/model/enums/state.enums';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-c-image-gallery',
  imports: [
    SHeaderComponent,
    BaseImageGalleryComponent,
    CommonModule
  ],
  templateUrl: './c-image-gallery.component.html',
  styleUrl: './c-image-gallery.component.scss'
})
export class CImageGalleryComponent extends CBaseComponent implements OnInit {

  override ngOnInit() {
    this.singleLabels = [ElementsType.ComponentHeader, ElementsType.GalleryConfig];
    super.ngOnInit();
  }
}
